export const SIGNUP_URL = 'lidmaatschap';
export const FRIEND_URL = 'vriendendienst';
export const PRIVACY_URL = 'privacy-statement';
